import styled from '@emotion/styled'
import { Card } from 'react-bootstrap'
import { ITheme } from 'application/utils/type'

interface IInputProps {
  theme: ITheme
}

export const ChecklistCardHeader = styled(Card.Header)<IInputProps>`
  label: ChecklistCardHeader;
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.primaryLightText};
  border-bottom: 0;
`

export const ItemNumber = styled('label')`
  label: ItemNumber;
  bottom: 7px;
  position: relative;
  padding-left: 10px;
`
export const CheckListItem = styled.div`
  label: CheckListItem;
  display: flex;
  align-items: flex-start;
  padding-bottom: 5px;
  margin-top: 4px;
`

export const CheckListText = styled('label')<IInputProps>`
  label: CheckListText;
  position: relative;
  bottom: 7px;
  padding-left: 8px;
  flex: 14;
  display: inline;
  > a {
    font-weight: bold;
    color: inherit;
    text-decoration: underline;
    color: ${(props) => props.theme.colors.linkColor};
  }
`
export const SubHeading = styled.div`
  label: SubHeading;
  font-weight: 700 !important;
  padding-bottom: 10px;
`

export const Tickbox = styled('input')`
  label: Tickbox;
  /* type: checkbox; */
  width: 20px;
  height: 20px;
  flex: 0.75;
`
export const CheckItemContainer = styled('div')`
  label: CheckItemContainer;
  display: flex;
  > span > div {
    display: flex;
  }
`
export const PrimaryText = styled('div')<IInputProps>`
  label: PrimaryText;
  color: ${(props) => props.theme.colors.primary};
`
